module.exports = __webpack_public_path__ + "static/media/agrtucal-speacial.df8fdbf9.png";